import { _t, i18n } from "app/i18n/i18n";
import { removeParam, setParam, push, getQueryString, resetToFirstPage } from "api/search/filterUrlMaker";

export const onMenuChange = (field, value) => {
  const qs = removeQueryParams(field);

  if (isEconomicDataRedirect(value)) {
    push(null, redirectMap[value]);
    return;
  }

  if (value === "Podcast") {
    const baseUrl = window.location.origin;
    const language = i18n.getLanguage() === "ja" ? "jp/" : "";
    const path = `/research/m/GotoWarning?url=https://www.nomuraconnects.com/${language}podcasts&warn=1&target=_blank`;
    window.location.assign(`${baseUrl}${path}`);
    return;
  }

  if (isAllOption(value)) {
    value = "";
  }

  if (value) {
    push(resetToFirstPage(setParam(field, value, qs)));
  } else {
    push(resetToFirstPage(removeParam(field, undefined, qs)));
  }
};

export const onKeywordSubmit = (ev) => {
  const qs = removeParam("", undefined, removeParam("From"));
  push(setParam("", ev.target.value, qs));
};

// if making a subCategory selection, remove periodicals, or vice versa.
function removeQueryParams(field) {
  let qs = getQueryString();
  if (field === "txSubCategories.en" || field === "txSubCategories.ja") {
    qs = removeParam("periodicals.en", undefined, qs);
    qs = removeParam("periodicals.ja", undefined, qs);
  } else if (field === "periodicals.en" || field === "periodicals.ja") {
    qs = removeParam("txSubCategories.en", undefined, qs);
    qs = removeParam("txSubCategories.ja", undefined, qs);
  }
  return qs;
}

const isEconomicDataRedirect = (subCategory) =>
  [
    "Economic Forecasts",
    "世界経済見通し要約",
    "為替予想",
    "FX Forecasts",
    "株価指数見通し",
    "Share Price Index Forecast",
    "マクロ・ストラテジー・ダッシュボード",
  ].includes(subCategory);

const redirectMap = {
  "Economic Forecasts": "/Economic_Data/Economics",
  "FX Forecasts": "/Economic_Data/FX",
  為替予想: "/Economic_Data/FX",
  世界経済見通し要約: "/Economic_Data/Economics",
  "株価指数見通し": "/Economic_Data/Equity",
  "Share Price Index Forecast": "/Economic_Data/Equity",
  "マクロ・ストラテジー・ダッシュボード": "/Economic_Data/Macro Strategy"
};

const isAllOption = (value) =>
  value === "All Regions" || value === _t("All Categories") || value === _t("All Periodicals");
